import { useState, useParams, BiCategory, FaEye, ToastContainer, MdErrorOutline, FaArrowAltCircleRight, overlayStyle, loaderStyle } from '../../common/common';

import useNavigation from '../../common/useNavigation';
import { useErrorContext } from '../../context/ErrorContext';
import MidAddCategory from '../../middleware/Categories/MidAddCategory';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';


const AddCategory = () => {
    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const { error } = useErrorContext();
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { values, users, userPlan, handleChange, handleFileChange, handleSubmit, fileInputRef, isLoading } = MidAddCategory(type);
    const { navigateViewCategories, navigatePlans } = useNavigation();
    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var ActiveUser = users[0]["Status"]
    }
    
    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }


    return (
        <div className='md:flex md:flex-row md:w-full'>
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full  md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="w-full ">
                    <div className="col-start-1 col-end-13">
                        <div className=" p-2 text-xl text-[#1e3a8a]">
                            <div className='px-3'>
                                <h1 className=' text-lg text-theme-color-text font-bold'> Product Categories</h1>
                                <p className=' text-gray-600 text-[16px] '>A product category is a group of similar type of products. Ex. Menswear,Womenswear,Childrenswear</p>
                            </div>
                        </div>
                    </div>

                    {ActiveUser === 1 ? (
                        <div className="border-0 flex-row rounded-xl m-3  bg-white shadow-xs ">
                            <div className=' relative flex flex-col min-w-0 break-words'>
                                <div className='p-4'>
                                    <div className='flex flex-row lg:flex-row justify-between items-center mb-4'>
                                        <h5 className=" capitalize text-xl font-bold mb-0">Add Category</h5>
                                        <button type="submit" className="relative rounded-md group px-3 h-12  flex space-x-2 items-center bg-button-color  hover:bg-button-color w-[200px]" onClick={navigateViewCategories}>
                                            <span className="relative text-md text-black font-semibold pl-0" >View All category</span>
                                            <div className=" items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl hidden lg:block py-3 ">
                                                <FaEye className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                                            </div>
                                        </button>
                                    </div>
                                    <form method='POST' onSubmit={handleSubmit}>
                                        <div className='row'>
                                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 my-3 ">
                                                <div>
                                                    <label className="block my-3">
                                                        <span className="block text-sm font-medium text-slate-700">Product Category </span>
                                                    </label>
                                                    <div className="flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md">
                                                        <BiCategory className=' text-gray-400' />
                                                        <input
                                                            className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                            type="text"
                                                            name="CategoryName"
                                                            id="CategoryName"
                                                            placeholder="Enter Product Category"
                                                            autoComplete="new-password"
                                                            value={values.CategoryName}
                                                            onChange={handleChange} />
                                                        {error.CategoryName && <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />}
                                                    </div>
                                                    {error.CategoryName && <p className='my-2 px-2 text-red-600 text-xs'>{error.CategoryName}</p>}
                                                </div>
                                                <div>
                                                    <label className="block my-3">
                                                        <span className="block text-sm font-medium text-slate-700">Product Category Image</span>
                                                    </label>
                                                    <div className='flex flex-row '>

                                                        <label className="block">
                                                            <span className="sr-only">Choose Category photo</span>
                                                            <input type="file" className="block w-full text-sm text-slate-500
                                                                file:mr-4 file:py-2 file:px-4
                                                                file:rounded-full file:border-0
                                                                file:text-sm file:font-semibold
                                                                file:bg-violet-50 file:text-theme-color-yellow
                                                                hover:file:bg-violet-100"
                                                                name="CategoryImg"
                                                                id="CategoryImg"
                                                                ref={fileInputRef}
                                                                onChange={handleFileChange}
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='flex justify-start mt-4'>
                                                <button type="button" className="relative rounded-md group px-3 h-12  flex space-x-2 items-center bg-button-color  hover:bg-button-color w-[150px]" onClick={handleSubmit}>
                                                    <span className="relative text-md text-black font-semibold pl-6">Submit</span>
                                                    <div className="flex items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl ">
                                                        <FaArrowAltCircleRight className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                                                    </div>
                                                </button >
                                            </div>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>

                    ) : (
                        <div class="col-start-1 col-end-13  my-5 px-3">
                            <div class="flex items-start p-3  bg-red-700  border-[1px] border-l-4 border-red-500 rounded-lg relative">
                                <div class="flex-shrink-0 text-white">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentcolor" viewBox="0 0 24 24">
                                        <path fill="none" d="M0 0h24v24H0z" />
                                        <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm-1 15l-5-5 1.41-1.42L11 14.17l6.59-6.59L19 9z" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <h2 class="text-lg font-semibold text-white">New Plan Purchased 🎉</h2>
                                    <p class="text-white">A new Plan has successfully completed a purchase.</p>
                                </div>
                                <div class="ml-auto">
                                    <button class="bg-white text-blue-600 font-medium px-4 py-2 rounded-lg border border-blue-600 hover:bg-blue-50 transition"
                                        onClick={() => { navigatePlans(type) }}
                                    >
                                        Buy Purchase Plan
                                    </button></div>
                            </div>
                        </div>

                    )}

                    <ToastContainer />
                </div>
            </div>
            {isLoading && (
                <div style={overlayStyle}>
                    <div style={loaderStyle}>Loading...</div>
                </div>
            )}
        </div >
    )
}

export default AddCategory